import { useEffect, useState } from "react";
import { CodeEditor, type PinnedRange } from "../CodeEditor";
import { ReadmeContent } from "../ReadmeContent";
import type { FileRenderControl, FileSelection } from "./types";

const filePath = "output.md";

type Props = {
  output: string;
  selectedRanges?: readonly PinnedRange[];
  onSelect?: (selections: FileSelection[]) => void;
  onControls?: (controls: FileRenderControl[]) => void;
};

export function Markdown({
  output,
  selectedRanges,
  onSelect,
  onControls,
}: Props) {
  const [showSource, setShowSource] = useState(
    () => localStorage.getItem("markdownViewMode") === "source"
  );

  useEffect(() => {
    if (!onControls) return;
    onControls([
      {
        id: "markdown-view",
        icon: "square-code",
        activeIcon: "newspaper",
        label: showSource ? "View rendered" : "View source",
        active: showSource,
        onToggle: () => {
          setShowSource(!showSource);
          localStorage.setItem(
            "markdownViewMode",
            showSource ? "rendered" : "source"
          );
        },
      },
    ]);
    return () => onControls([]);
  }, [onControls, showSource]);

  if (showSource) {
    return (
      <CodeEditor
        filePath={filePath}
        value={output}
        onSelectionChange={
          onSelect &&
          ((selections) =>
            onSelect(
              selections.map((s) => ({
                from: s.from,
                to: s.to,
                fromLine: s.fromLine,
                toLine: s.toLine,
                text: s.text,
              }))
            ))
        }
        pinnedRanges={selectedRanges}
      />
    );
  }

  return <ReadmeContent>{output}</ReadmeContent>;
}
